import React from 'react';

import { Grid, Typography, makeStyles, useTheme } from '@material-ui/core';
import i18n from 'i18n';
import {
  AvgMaxCountAccess,
  PeriodCountAccess,
  DateFilterFields,
} from 'modules/environments/interfaces';
import ApplicationState from 'store/interfaces';
import { connect } from 'react-redux';
import AutoCard from 'components/AutoCard';
import FilterSelector from 'components/FilterSelector';
import { filterAvgMaxOptions } from 'utils/graphs';
import {
  getEnvironmentPerformanceMemoryRequest,
  setEnvironmentAvgMaxFilterMemory,
} from 'modules/environments/actions';
import { useParams } from 'react-router';
import { modalOpen } from 'modules/modal/actions';
import { ModalFields } from 'modules/modal/interfaces';
import MemoryGraph from './MemoryGraph';
import styles, {
  overrideCardGraph,
  overrideFilter,
  overrideModalGraph,
} from './styles';
import MemoryGraphModal from './MemoryGraphModal';

interface MemoryGraphCardProps {
  avgMaxFilter: AvgMaxCountAccess;
  dateFilter?: DateFilterFields;
  intervalTime: PeriodCountAccess;
  modalOpen: (props: ModalFields) => void;
  setEnvironmentAvgMaxFilterMemory: (prop: string) => void;
  getEnvironmentPerformanceMemoryRequest: ({ id, query }) => void;
}

const MemoryGraphCard = ({
  avgMaxFilter,
  dateFilter,
  intervalTime,
  modalOpen,
  setEnvironmentAvgMaxFilterMemory,
  getEnvironmentPerformanceMemoryRequest,
}: MemoryGraphCardProps) => {
  const classes = makeStyles(styles())();
  const { id } = useParams<{
    id: string;
  }>();
  const { breakpoints } = useTheme();

  const getEnvironmentPerformanceMemory = React.useCallback(() => {
    const query =
      dateFilter?.['start-date'] && dateFilter?.['end-date']
        ? dateFilter
        : { period: intervalTime };

    getEnvironmentPerformanceMemoryRequest({
      id,
      query,
    });
  }, [getEnvironmentPerformanceMemoryRequest, intervalTime, id, dateFilter]);

  React.useEffect(() => {
    getEnvironmentPerformanceMemory();
  }, [getEnvironmentPerformanceMemory]);

  const handleOpenGraphModal = () => {
    modalOpen({
      overrideClasses: overrideModalGraph,
      maxWidth: 'xl',
      title: i18n.t('PERFORMANCE_PAGE.MEMORY_USE_DETAILS_KEY'),
      content: <MemoryGraphModal />,
      onClose: () => getEnvironmentPerformanceMemory(),
      genericFooter: {},
    });
  };

  return (
    <Grid item className={classes.containerCard}>
      <Grid item>
        <Grid container alignItems="center" justify="space-between">
          <Grid item>
            <Typography className={classes.graphTitle}>
              {i18n.t('PERFORMANCE_PAGE.MEMORY_USE_KEY')}
            </Typography>
          </Grid>
          <Grid item className={classes.gridFilters}>
            <FilterSelector
              overrideClasses={overrideFilter}
              options={filterAvgMaxOptions(setEnvironmentAvgMaxFilterMemory)}
              currentValue={{
                label: i18n.t(
                  `PERFORMANCE_PAGE.${avgMaxFilter.toUpperCase()}_KEY`
                ),
                onClick: () => null,
              }}
            />
          </Grid>
        </Grid>
      </Grid>
      <AutoCard overrideClasses={overrideCardGraph(breakpoints)}>
        <Grid
          container
          className={classes.containerGraph}
          onClick={handleOpenGraphModal}
        >
          <MemoryGraph filter={avgMaxFilter} />
        </Grid>
      </AutoCard>
    </Grid>
  );
};

const mapStateToProps = ({
  environments: { periodFilter, environmentAvgMaxFilterMemory },
}: ApplicationState) => ({
  intervalTime: periodFilter,
  avgMaxFilter: environmentAvgMaxFilterMemory,
});
export default connect(mapStateToProps, {
  setEnvironmentAvgMaxFilterMemory,
  getEnvironmentPerformanceMemoryRequest,
  modalOpen,
})(MemoryGraphCard);
